module.exports = __webpack_public_path__ + "img/00036.b331b860.webp";